
<template>
  <div>
    <!-- <mheader></mheader> -->
    <div
      v-show="tableData.length > 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            返利信息管理
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
          </span>

          <span class="ml-5" style="color: red">
            每天晚上8点以后,早晨6点前不能进行返利操作
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600">(单击表头显示列表信息)</span>
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font heit"
                          v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
            </div>
          </div>
        </div>

        <table
          v-if="searchData.length > 0"
          class="table table-striped table-hover sett"
          ref="print"
        >
          <thead>
            <tr
              style="white-space: nowrap"
              @click="changeWidth($event)"
              class="text-center"
            >
              <th class="autocut">药品名称</th>
              <th class="autocut">产地名称</th>
              <th class="autocut">库区</th>
              <th class="autocut">规格</th>
              <th class="autocut">批号</th>
              <th class="autocut">包装</th>
              <th class="autocut">可售数量</th>
              <!-- <th class="autocut">进价</th> -->
              <th class="autocut">批价</th>
              <th class="autocut">有效期</th>
              <th class="autocut">开始日期</th>
              <th class="autocut">截至日期</th>
              <!-- <th class="autocut">电话</th> -->
              <!-- <th class="autocut">积分</th> -->
              <!-- <th class="autocut" style="color:red;">礼品</th> -->
              <!-- <th class="autocut">礼品数</th> -->
              <!-- <th class="autocut">礼品单位</th> -->
              <!-- <th class="autocut">是否量大可议价</th> -->
              <!-- <th class="autocut">返金额</th> -->
              <th class="autocut" style="color: green">状态</th>

              <th style="width: 200px">返利信息</th>
              <th style="width: 100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in searchData"
              :key="index"
              class="text-center"
            >
              <td class="jz_middle sett-td" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td
                class="jz_middle sett-td"
                @dblclick="onInputcustomerName(index)"
              >
                {{ item.productFactory }}
              </td>
              <td class="jz_middle sett-td">{{ item.storeNo }}</td>
              <td class="jz_middle sett-td">{{ item.spec }}</td>
              <td class="jz_middle sett-td">{{ item.batchNum }}</td>
              <td class="jz_middle sett-td">{{ item.pack }}</td>
              <td class="jz_middle sett-td">{{ item.canSaleNum }}</td>
              <!-- <td class="jz_middle sett-td">{{item.purchPrice}}</td> -->
              <td class="jz_middle sett-td">{{ item.tradePrice }}</td>
              <td class="jz_middle sett-td">{{ item.realDueDate }}</td>
              <td class="jz_middle sett-td">
                {{ item.beginDate | formatUTC }}
              </td>
              <td class="jz_middle sett-td">{{ item.endDate }}</td>
              <!-- <td class="jz_middle sett-td">{{item.contract}}</td> -->
              <!-- <td class="jz_middle sett-td">{{item.fJF}}</td> -->
              <!-- <td class="jz_middle sett-td" style="color:red;">{{item.gift}}</td> -->
              <!-- <td class="jz_middle sett-td">{{item.giftNum}}</td> -->
              <!-- <td class="jz_middle sett-td">{{item.giftUnit}}</td> -->
              <!-- <td class="jz_middle sett-td">{{item.intLDKYJ | bargain}}</td> -->
              <!-- <td class="jz_middle sett-td">{{item.money}}</td> -->
              <td class="jz_middle sett-td" style="color: green">
                {{ item.state | status }}
              </td>
              <td class="jz_middle">{{ item.isPromotion }}</td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="changeInformation(index, item)"
                >
                  修改
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-hover sett" ref="print" v-else>
          <thead>
            <tr
              style="white-space: nowrap"
              @click="changeWidth($event)"
              class="text-center"
            >
              <th class="autocut">药品名称</th>
              <th class="autocut">产地名称</th>
              <th class="autocut">库区</th>
              <th class="autocut">规格</th>
              <th class="autocut">批号</th>
              <!-- <th>单位</th> -->
              <!-- <th>单价</th> -->
              <!-- <th>零/整</th> -->
              <th class="autocut">包装</th>
              <th class="autocut">可售数量</th>
              <!-- <th class="autocut">进价</th> -->
              <th class="autocut">批价</th>
              <th class="autocut">有效期</th>
              <th class="autocut">开始日期</th>
              <th class="autocut">截至日期</th>
              <!-- <th class="autocut">电话</th>
                        <th class="autocut">积分</th>
                        <th class="autocut" style="color:red;">礼品</th>
                        <th class="autocut">礼品数</th>
                        <th class="autocut">礼品单位</th>
                        <th class="autocut">是否量大可议价</th>
                        <th class="autocut">返金额</th> -->
              <th style="color: green" class="autocut">状态</th>

              <th style="width: 200px">返利信息</th>
              <th style="width: 100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in tableData"
              :key="index"
              class="text-center"
            >
              <td class="jz_middle sett-td" @dblclick="onInputdrugName(index)">
                {{ item.drugName }}
              </td>
              <td
                class="jz_middle sett-td"
                @dblclick="onInputcustomerName(index)"
              >
                {{ item.productFactory }}
              </td>
              <td class="jz_middle sett-td">{{ item.storeNo }}</td>
              <td class="jz_middle sett-td">{{ item.spec }}</td>
              <td class="jz_middle sett-td">{{ item.batchNum }}</td>
              <!-- <td class="jz_middle">{{item.unit}}</td> -->
              <!-- <td class="jz_middle">{{item.price}}</td> -->
              <!-- <td class="jz_middle">{{item.isRetail | lin}}</td> -->
              <td class="jz_middle sett-td">{{ item.pack }}</td>
              <td class="jz_middle sett-td">{{ item.canSaleNum }}</td>
              <!-- <td class="jz_middle sett-td">{{item.purchPrice}}</td> -->
              <td class="jz_middle sett-td">{{ item.tradePrice }}</td>
              <td class="jz_middle sett-td">{{ item.realDueDate }}</td>
              <td class="jz_middle sett-td">
                {{ item.beginDate | formatUTC }}
              </td>
              <td class="jz_middle sett-td">{{ item.endDate | formatUTC }}</td>
              <!-- <td class="jz_middle sett-td">{{item.contract}}</td>
                              <td class="jz_middle sett-td">{{item.fJF}}</td>
                              <td class="jz_middle sett-td" style="color:red;">{{item.gift}}</td>
                              <td class="jz_middle sett-td">{{item.giftNum}}</td>
                              <td class="jz_middle sett-td">{{item.giftUnit}}</td>
                              <td class="jz_middle sett-td">{{item.intLDKYJ | bargain}}</td>
                              <td class="jz_middle sett-td">{{item.money}}</td> -->
              <td class="jz_middle sett-td" style="color: green">
                {{ item.state | status }}
              </td>
              <td class="jz_middle">{{ item.isPromotion }}</td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="changeInformation(index, item)"
                >
                  修改
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- 分页 -->

        <div>
          <v-pagination
            :total="total"
            :current-page="current"
            @pagechange="pagechange"
          ></v-pagination>
        </div>

        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
        <!-- <p class="text-right">
            <span class="mt-2">
              总共有
              <span style="color:green;font-size:20px">{{Record}}</span>
              条数据
            </span>
            <span>
                总金额:
                <span style="color:red;font-size:15px;">
                   ¥{{totalMoney}}
                </span>
            </span>
      </p>
           -->
      </div>
      <!-- container -->
    </div>

    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <!-- 表单内容 -->
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            返利信息管理
          </span>
          <span class="ml-5">
            <span class="mt-2">
              总共有
              <span style="color: green; font-size: 20px">{{ Record }}</span>
              条数据
            </span>
            <!-- <span>
                         <span class="ml-3">
                              总金额:
                         </span>
                          <span style="color:red;font-size:15px;">
                            ¥{{totalPurchMoney}}
                          </span>
                      </span> -->
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <p class="query mb-2 mt-2">
          <span style="font-weight: 600">(单击表头显示列表信息)</span>
        </p>
        <div class="row ml-2 mb-2">
          <div class="col-lg-9">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font heit"
                          v-model="searchForm.ypmc"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">批号:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ph"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row ml-lg-3">
              <button class="bg-primary button_zi heit" @click="Search()">
                查询
              </button>
              <!-- <button class="bg-success button_zi ml-lg-2" @click="start_print()">打印页面</button>
                                 <button class="bg-success button_zi ml-lg-2" @click="exportExcel1()">导出本页</button>
                                 <button class="bg-success button_zi ml-lg-2" @click="exportExcel()">导出查询EXCEL</button> -->
            </div>
          </div>
        </div>
        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
    </div>

    <div>
      <transition name="fade">
        <loading v-show="isLoading"> </loading>
      </transition>
    </div>

    <!-- 这里是弹出框的内容 -->

    <!-- 弹出提示框 -->

    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="
            width: 800px;
            height: 500px;
            position: relative;
            top: 200px;
            left: 20px;
            margin-bottom: 50px;
          "
        >
          <!-- <div>
                                    <button type="button" class="close m-0 p-1" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div> -->
          <div class="modal-body">
            <form class="m-muto">
              <table style="width: 600px; height: 400px; margin-left: 50px">
                <tr>
                  <td style="font-weight: 600">积分:</td>
                  <td class="text-right" style="width: 80px">
                    <span>返---</span>
                  </td>
                  <td>
                    <input
                      class="input_form-control"
                      v-model="integral"
                      type="text"
                      :disabled="isdisabled"
                    />
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td style="font-weight: 600">礼物:</td>
                  <td class="text-right">
                    <span>返---</span>
                  </td>
                  <td>
                    <input
                      class="input_form-control"
                      v-model="inputgift"
                      type="text"
                    />
                  </td>
                  <td>
                    <span style="color: red"> (最多10个字) </span>
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: 600">礼物数量:</td>
                  <td></td>
                  <td>
                    <input
                      class="input_form-control"
                      v-model="giftNumber"
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: 600">礼物单位:</td>
                  <td></td>
                  <td>
                    <input
                      class="input_form-control"
                      v-model="giftUnit"
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: 600">金额:</td>
                  <td class="text-right">
                    <span>返利金额---</span>
                  </td>
                  <td>
                    <input
                      class="input_form-control"
                      v-model="giftMoney"
                      type="text"
                      :disabled="isdisabled"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: 600">手机号:</td>
                  <td></td>
                  <td>
                    <select v-model="phoneNumber" class="input_form-control">
                      <option value="">请选择手机号码</option>
                      <option
                        v-for="(item, index) in phones"
                        :key="index"
                        :value="item.tel"
                        v-text="item.tel"
                      ></option>
                    </select>
                  </td>
                  <td>
                    <!-- <button
                      class="bg-primary button_zi heit ml-3"
                      :disabled="disabled"
                      @click.prevent="getCode()"
                    >
                      {{ btnText }}
                    </button> -->
                  </td>
                </tr>
                <tr>
                  <td style="font-weight: 600">二级密码:</td>
                  <td></td>
                  <td>
                    <input
                      type="text"
                      class="input_form-control"
                      v-model="yzm"
                    />
                  </td>
                  <td>
                    <el-link href="/secondpass">忘记密码?</el-link></span>
                  </td>
                </tr>
              </table>
            </form>

            <p style="height: 30px; display: flex; align-items: center">
              <span style="margin-left: 51px; font-weight: 600"> 日期: </span>
              <date
                style="margin-left: 147px"
                @changeDate="changeDate1($event)"
              />
              <date4
                style="margin-left: 50px"
                class="picker2"
                @changeDate="changeDate2($event)"
              />
            </p>

            <div style="text-align: right">
              <button
                type="button"
                class="btn btn-primary"
                @click="createdrugrebate()"
              >
                确认
              </button>
              <button
                type="button"
                class="btn btn-info ml-3"
                data-dismiss="modal"
              >
                <span aria-hidden="true"></span>取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import date from "../components/Date.vue";
import date4 from "../components/Date/Date4.vue";
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
        DateMoreThan: "",
        DateLessThan: "",
      }, //搜索内容
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      excelData: [],
      totalPurchMoney: "",

      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数

      phones: [],
      phoneNumber: "",
      disabled: false,

      totalCount: 0,

      integral: "", //积分
      inputgift: "", //礼物
      giftNumber: "", //礼物数量
      giftUnit: "", //礼物单位
      giftMoney: "", //金额
      id: "", //选择要修改的id
      yzm: "",

      yema: 1, //这里是页码

      isdisabled: false,
    };
  },
  components: {
    vPagination,
    Loading,
    date,
    date4,
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : "获取验证码";
    },
  },
  filters: {
    //过滤器时间转换
    //时间转换

    //状态
    status: function (state) {
      if (state == 2) {
        return "审核通过";
      } else {
        return "未审核";
      }
    },

    //是否量大可议价
    bargain: function (price) {
      if (price == 1) {
        return "是";
      } else if (price == 0) {
        return "否";
      }
    },

    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },
    lin: function (data) {
      if (data == 1) {
        return "零";
      } else {
        return "整";
      }
    },
    rate: function (rate) {
      if (rate == 1) {
        return "不打折";
      } else {
        return "打" + rate * 10 + "折";
      }
    },
  },

  methods: {
    getCode() {
      const that = this;
      //  console.log(that.phoneNumber)
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!that.phoneNumber) {
        alert("输入的手机号码不能为空！");
      } else if (!reg.test(that.phoneNumber)) {
        alert("您输入的手机号码有错误！");
      } else {
        that.getsendMessage();
      }
    },
    getsendMessage: async function () {
      //按钮120秒倒计时
      await this.sendMessage(); //120秒倒计时过后才能调用事件
      if (this.success) {
        this.totalCount = 120;
        this.disabled = true;
        this.interval = setInterval(() => {
          this.totalCount--;
          if (this.totalCount === 0) {
            clearInterval(this.interval);
            this.disabled = false;
          }
        }, 1000);
      }
    },
    sendMessage: async function () {
      const that = this;
      await that.$http
        .post("/Dls/addaccount", { phone: that.phoneNumber })
        .then((response) => {
          //  console.log(response)
          if (response.data.isOk) {
            that.success = true;
            // alert("信息已发送，请注意查收")
            that.$message.success("信息已发送，请注意查收!");
          } else if (!response.data.isOk) {
            if (response.data.errorMessage == -3) {
              alert("发送一次短信可以使用1天，1天内不需要发送新短信");
            } else if (response.data.errorMessage == -4) {
              alert("短信发送失败，请联系管理员！");
            }
          }
        });
    },

    //获取日期
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);

      // console.log(tYear +""+ tMonth + ""+tDate)
      return tYear + "" + tMonth + "" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },

    //动态绑定时间
    changeDate1: function (date) {
      this.searchForm.DateLessThan = date.replace(/\-/g, "");
      //  console.log(this.searchForm.DateLessThan)
      // this.searchForm.DateLessThan1=date;
      // console.log(this.searchForm.DateLessThan1)
    },
    changeDate2: function (date) {
      let year = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getFullYear();

      let month =
        new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000).getMonth() + 1;

      let time_date = new Date(
        new Date(date).getTime() + 24 * 60 * 60 * 1000
      ).getDate();
      // console.log(time_date)
      let time;
      if (month < 10) {
        if (time_date < 10) time = "" + year + "0" + month + "0" + time_date;
        else {
          time = "" + year + "0" + month + time_date;
        }
      } else {
        if (time_date < 10) {
          time = "" + year + month + "0" + time_date;
        } else {
          time = "" + year + month + time_date;
        }
      }

      this.searchForm.DateMoreThan = time;
      // console.log(time)
      // this.searchForm.DateMoreThan1=date;
      // console.log(this.searchForm.DateMoreThan1)
    },

    //确定修改信息

    createdrugrebate: async function () {
      const that = this;
      // let reg = /^\w{0,10}$/  //十个字
      let reg1 = /^-?[1-9]\d*$/; //整数
      let reg2 = /[\u4E00-\u9FA5]/; //汉字
      if (that.inputgift == "" && that.integral == "" && that.giftMoney == "") {
        that.$message.warning("积分，礼物，金额 三个必须填一个!");
      }else if (that.phoneNumber == "") {
        that.$message.warning("未选择手机号!");
      }
      else if (that.yzm == "") {
        that.$message.warning("未输入二级密码!");
      }
      else if (that.yzm.length != 6) {
        that.$message.warning("您输入的二级密码位数有误！");
      } else if (that.integral !== "" && that.integral <= 0) {
        that.$message.warning("积分要大于0!");
      } else if (that.giftMoney !== "" && reg2.test(that.giftMoney) == true) {
        that.$message.warning("输入金额不能为汉字!");
      } else if (that.giftMoney !== "" && that.giftMoney <= 0) {
        that.$message.warning("金额要大于0!");
      } else if (that.inputgift !== "" && that.inputgift.length > 9) {
        that.$message.warning("最多十个字!");
      } else if (that.inputgift !== "") {
        if (that.giftNumber == "" || that.giftUnit == "") {
          that.$message.warning("礼物数量和单位必须填!");
        } else if (
          that.giftNumber !== "" &&
          reg1.test(that.giftNumber) == false
        ) {
          that.$message.warning("礼物数量输入必须为整数!");
        } else if (that.giftNumber !== "" && that.giftNumber <= 0) {
          that.$message.warning("礼物数量要大于0!");
        } else {
          let ces = that.searchForm.DateLessThan;
          let a =
            ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
          let ces1 = that.searchForm.DateMoreThan;
          let b =
            ces1.slice(0, 4) + "-" + ces1.slice(4, 6) + "-" + ces1.slice(6, 9);
          let cesTime = new Date(a).getTime();
          let cesTime2 = new Date(b).getTime();
          if (cesTime >= cesTime2) {
            alert("开始日期要小于结束日期");
          } else {
            // console.log('正在修改')

            let ces = that.searchForm.DateLessThan;
            let a =
              ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
            let ces1 = that.searchForm.DateMoreThan;
            let b =
              ces1.slice(0, 4) +
              "-" +
              ces1.slice(4, 6) +
              "-" +
              ces1.slice(6, 9);
            let cesTime = new Date(a).getTime();
            let cesTime2 = new Date(b).getTime();
            if (cesTime >= cesTime2) {
              alert("开始日期要小于结束日期");
            } else {
              // console.log('正在修改')
              let nowintegral, nowgiftMoney, nowgiftNumber;
              if (that.integral == "") {
                nowintegral = 0;
              } else {
                nowintegral = that.integral;
              }
              if (that.giftMoney == "") {
                nowgiftMoney = 0;
              } else {
                nowgiftMoney = that.giftMoney;
              }
              if (that.giftNumber == "") {
                nowgiftNumber = 0;
              } else {
                nowgiftNumber = that.giftNumber;
              }
              // console.log(nowintegral)
              // console.log(nowgiftMoney)
              await that.$http
                .post("Dls/CreatedrugrebatexNew", {
                  StoreID: that.id, //库存ID
                  FJF: nowintegral, //积分
                  GiftNum: nowgiftNumber,
                  GiftUnit: that.giftUnit,
                  Gift: that.inputgift,
                  Money: nowgiftMoney,
                  Contract: that.phoneNumber, //电话
                  BeginDate: that.searchForm.DateLessThan, //开始时间
                  EndTime: that.searchForm.DateMoreThan, //截至时间
                  yzm: that.yzm,
                  LDkyJ: "0", //是否量大可议价
                })
                .then((res) => {
                  // console.log(res);
                  if (res.data.isOk) {
                    if (res.data.data.result.isSucceed) {
                      $("#myModal").modal("hide");
                      // that.$message.success(res.data.data.result.msg)
                      alert(res.data.data.result.msg);
                      that.pagechange(that.yema);
                    } else {
                      alert(res.data.data.result.msg);
                    }
                  } else {
                    alert(res.data.message);
                  }
                });
            }
          }
        }
      } else {
        let ces = that.searchForm.DateLessThan;
        let a = ces.slice(0, 4) + "-" + ces.slice(4, 6) + "-" + ces.slice(6, 9);
        let ces1 = that.searchForm.DateMoreThan;
        let b =
          ces1.slice(0, 4) + "-" + ces1.slice(4, 6) + "-" + ces1.slice(6, 9);
        let cesTime = new Date(a).getTime();
        let cesTime2 = new Date(b).getTime();
        if (cesTime >= cesTime2) {
          alert("开始日期要小于结束日期");
        } else {
          // console.log('正在修改')
          let nowintegral, nowgiftMoney, nowgiftNumber;
          if (that.integral == "") {
            nowintegral = 0;
          } else {
            nowintegral = that.integral;
          }
          if (that.giftMoney == "") {
            nowgiftMoney = 0;
          } else {
            nowgiftMoney = that.giftMoney;
          }
          if (that.giftNumber == "") {
            nowgiftNumber = 0;
          } else {
            nowgiftNumber = that.giftNumber;
          }
          // console.log(nowintegral)
          // console.log(nowgiftMoney)
          await that.$http
            .post("Dls/CreatedrugrebatexNew", {
              StoreID: that.id, //库存ID
              FJF: nowintegral, //积分
              GiftNum: nowgiftNumber,
              GiftUnit: that.giftUnit,
              Gift: that.inputgift,
              Money: nowgiftMoney,
              Contract: that.phoneNumber, //电话
              BeginDate: that.searchForm.DateLessThan, //开始时间
              EndTime: that.searchForm.DateMoreThan, //截至时间
              yzm: that.yzm,
              LDkyJ: "0", //是否量大可议价
            })
            .then((res) => {
              // console.log(res);
              if (res.data.isOk) {
                if (res.data.data.result.isSucceed) {
                  $("#myModal").modal("hide");
                  // that.$message.success(res.data.data.result.msg)
                  alert(res.data.data.result.msg);
                  that.pagechange(that.yema);
                } else {
                  alert(res.data.data.result.msg);
                }
              } else {
                alert(res.data.message);
              }
            });
        }
      }
    },

    //选择修改信息

    changeInformation: async function (index, item) {
      const that = this;
      that.integral = item.fJF == 0 ? "" : item.fJF;
      that.inputgift = item.gift == null ? "" : item.gift;
      that.giftNumber = item.giftNum == 0 ? "" : item.giftNum;
      that.giftUnit = item.giftUnit == null ? "" : item.giftUnit;
      that.giftMoney = item.money == null ? "" : item.money;
      // console.log(that.searchData.length)
      if (that.searchData.length > 0) {
        if (that.searchData[index].storeNo == "aa") {
          that.isdisabled = true;
        }
        that.id = that.searchData[index].storeID;
      } else {
        if (that.tableData[index].storeNo == "aa") {
          that.isdisabled = true;
        }
        that.id = that.tableData[index].storeID;
      }
      // console.log(that.id)

      await that.$http.post("/Dls/GetPhone2", {}).then((response) => {
        //  console.log(response)
        if (response.data.isOk) {
          that.phones = response.data.data.rows;
          // console.log(that.phones)

          $("#myModal").modal();
        } else {
          alert(response.data.message);
        }
      });
    },
    //单击改变宽度
    changeWidth: function (e) {
      if (e.target.className.indexOf("add_autocut") > -1) {
        $(e.target).removeClass("add_autocut");
      } else {
        $(e.target).addClass("add_autocut");
      }
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },
    //导出方法
    //导出查询页 默认全部查询
    exportExcel() {
      const that = this;
      require.ensure([], async () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "药品名称",
          "产地名称",
          "库区",
          "规格",
          "批号",
          "单位",
          "单价",
          "零/整",
          "包装",
          "数量",
          "有效期",
          "入账日期",
          "打折情况",
          "返利情况",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "drugName",
          "productFactory",
          "storeNo",
          "spec",
          "batchNum",
          "unit",
          "price",
          "isRetail",
          "pack",
          "storeNum",
          "dueDate",
          "inAccountDate",
          "disCountRate",
          "isPromotion",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        await that.getExcelData();
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
      });
    },
    //导出当前页
    exportExcel1() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "药品名称",
          "产地名称",
          "库区",
          "规格",
          "批号",
          "单位",
          "单价",
          "零/整",
          "包装",
          "数量",
          "有效期",
          "入账日期",
          "打折情况",
          "返利情况",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "drugName",
          "productFactory",
          "storeNo",
          "spec",
          "batchNum",
          "unit",
          "price",
          "isRetail",
          "pack",
          "storeNum",
          "dueDate",
          "inAccountDate",
          "disCountRate",
          "isPromotion",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        if (this.searchData.length > 0) {
          const list = this.searchData; //把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
        } else {
          const list = this.tableData; //把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, "库存查询"); //最后一个是表名字
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc = this.searchData[index].drugName;
      } else {
        this.searchForm.ypmc = this.tableData[index].drugName;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].productFactory;
      } else {
        this.searchForm.cdmc = this.tableData[index].productFactory;
      }
    },
    getClerkStoreGoodsQuery: async function (PageIndex) {
      // this.isLoading=true;
      // this.PageNo=PageIndex || this.PageNo
      await this.$http
        .post("Dls/Clerkdrugrebatequery", {
          PageIndex,
          PageSize: 20,
        })
        .then((res) => {
          // console.log(res)
          if (res.data.data.isok) {
            const obj = res.data.data;
            this.tableData = obj.rows;
            this.total = obj.record;
            this.Pcount = obj.pcount;
            this.Record = obj.record;
            this.totalPurchMoney = obj.totalPurchMoney;
            // this.isLoading=false
          }
        });
    },
    getExcelData: async function () {
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkStoreGoodsQuery",
        obj: JSON.stringify({
          PageIndex: 1,
          PageSize: 50000,
          DrugName: this.searchForm.ypmc.trim(),
          BatchNum: this.searchForm.ph.trim(),
          ProductFactory: this.searchForm.cdmc.trim(),
          Spec: this.searchForm.gg.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        this.excelData = obj.rows;
      }
    },
    //搜索
    Search: async function (PageIndex) {
      const that = this;
      // search 是 v-model="search" 的 search
      that.isLoading = true;
      //这里加表单验证，这块就不用我说了吧
      //假设表单验证通过，这时候就可以ajax提交表单
      if (!PageIndex) {
        PageIndex = 1;
      }
      that.PageNo = PageIndex || that.PageNo;
      await this.$http
        .post("Dls/Clerkdrugrebatequery", {
          PageIndex,
          PageSize: 20,
          DrugName: that.searchForm.ypmc.trim(),
          BatchNum: that.searchForm.ph.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          Spec: that.searchForm.gg.trim(),
        })
        .then((res) => {
          // console.log(res)
          if (res.data.data.isok) {
            const obj = res.data.data;
            if (that.Pcount === 0) {
              that.tableData = obj.rows;
            } else {
              that.searchData = obj.rows;
            }
            that.Pcount = obj.pcount;
            that.total = obj.record;
            that.Record = obj.record;
            that.isLoading = false;
            if (obj.pcount == 0) {
              alert("没有符合条件的信息");
              that.getClerkStoreGoodsQuery();
            }
          }
        });
    },

    pagechange: function (currentPage) {
      this.yema = currentPage;
      if (this.searchData.length > 0) {
        this.Search(currentPage);
      } else {
        this.getClerkStoreGoodsQuery(currentPage);
      }
    },
    //搜索功能
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getClerkStoreGoodsQuery();
    this.searchForm.DateMoreThan = this.getDay(365);
    this.searchForm.DateLessThan = this.getDay(0);
    // console.log(  this.searchForm.DateMoreThan)
    //this.getDay(365)
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.heit {
  height: 1.5rem;
}
.span_close:hover {
  color: #3190e8;
}

.sett-td {
  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;

  -moz-text-overflow: ellipsis;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.jz_middle {
  vertical-align: middle;
}

.autocut:hover {
  overflow: visible;
  width: 200px;
  white-space: nowrap;
  word-wrap: break-word;
  text-align: center;
}
.add_autocut {
  overflow: visible;
  width: 200px;
  white-space: nowrap;
  word-wrap: break-word;
  text-align: center;
}
.sett {
  width: 1300px;
  table-layout: fixed;
}
.input_form-control {
  /* // display: block;  */
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/RebateInformation.vue